<template>
  <div class="modal fade" id="addResource" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Add Resource</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label class="form-label">Resource Name</label>
          <div class="input-group">
            <input v-model="resourcesForm.permissionName" class="form-control" required>
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="resourcesForm.resourceId != '' " class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
            <button class="btn" @click="TryAddProjectRole()" data-bs-dismiss="modal" style="background-color: #499c4a;color: #ffffff">
              <font-awesome-icon icon="edit"/>
              <span class="mx-1">Update</span>
            </button>
          </div>
          <div v-else class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
            <button class="btn" @click="TryAddProjectRole()" data-bs-dismiss="modal" style="background-color: #56759c;color: #ffffff">
              <font-awesome-icon icon="save"/>
              <span class="mx-1">Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"
    export default {
        name: "AddResource",
        props: ['isActiveResourceModal', 'projectId','resourcesForm', 'pageId'],
        components:{
        },
        data() {
            return {
              userForm: {
                userId: [],
                projectId: 0,
              },
              resourceForm: {
                id:0,
                projectId:0,
                pageId:0,
                permissionName:"",
                permissionDescription:""

              }
            }
        },
        computed: {
          ...mapState('projects', ['userProject']),
          ...mapState('users' , ['userList']),
        },
        methods: {
           ...mapActions('users', ["getUsers"]),
           ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject']),
           ...mapActions('pages', ['getProjectPages','getPageResources','addResource']),

          openCloseResourceModal() {
                this.resourceForm.permissionName = "";
                this.$emit('openCloseResourceModal');
            },
            async TryAddProjectRole() {
              try {
                this.resourceForm.projectId = parseInt(this.projectId);
                this.resourceForm.pageId = parseInt(this.pageId);
                this.resourceForm.id = parseInt(this.resourcesForm.resourceId);
                this.resourceForm.permissionName = this.resourcesForm.permissionName;
                await this.addResource(this.resourceForm);
                await this.getProjectPages(this.resourceForm.projectId);
                await this.getPageResources(this.resourceForm.pageId);
                await this.openCloseResourceModal();
                this.$notify({title: "Success", type: "success", text: "Successfully added page."})
              } catch (e) {
                this.$notify({title: "Error", type: "error", text: e})
              }
            },
        },
        mounted() {
          document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.isActiveResourceModal = false;
                }
            })
        },
      created() {
          this.getUsers();
      }
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
